import { BREAKPOINT_DESKTOP_XL } from "constants/constants";
import styled, { css } from "styled-components/macro";

export const HIGHLIGHT_TILE_CLASS = "highlightCustomerTile";
export const HIGHLIGHT_INDICATOR_CLASS = "highlightFeatureFlagIndicator";

export const CustomerTilesNoTitlesMessageStyles = styled.div`
  margin-top: 4em;
  padding: 0 1em;
`;
export const CustomerTilesPanelStyles = styled.div<{
  $shouldShowSearch: boolean;
  $isPending: boolean;
}>`
  margin-top: ${props => (props.$shouldShowSearch ? 1 : 4)}em;
  margin-bottom: 2em;

  /* Just for IE 11, instead of the grid layout we use -ms-flexbox.
     The display will fall back to -ms-flexbox, and -ms-flex-wrap
     should get ignored by better browsers. */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  /* Modern browsers will use grid for layout.
  display: grid;
  grid-gap: 5px;
  justify-items: left;
  justify-content: center;

}px; */

  .${HIGHLIGHT_TILE_CLASS} {
    border: 3px solid black !important;
  }
  .${HIGHLIGHT_INDICATOR_CLASS} {
    transform: scale(2);
    transform-origin: center;
  }
  ${props =>
    props.$isPending
      ? css`
          .customerTileButton {
            opacity: 0.75;
          }
        `
      : ""}
`;

const COMMON_INDICATOR_STYLES = `
  width: 8px;
  height: 8px;
  border-radius: 100%;
`;

const inactive = "hsla(0, 0%, 50%, 0.1)";

export const SearchStyles = styled.div`
  display: flex;
  gap: 1em;
  margin: 1em auto;
  width: fit-content;
  border-radius: 8px;
  max-width: calc(100% - 200px);
  flex-wrap: wrap;
  justify-content: center;
  .inputWrapper {
    background: white;
    position: relative;
    button {
      position: absolute;
      right: 4px;
      top: 4px;
      bottom: 0;
      width: 48px;
      height: 48px;
    }
  }
  .more-info-search-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    margin: 4em auto;
    transform: scale(2.4);
  }
`;

export const FeatureFlagsLegendStyles = styled.div`
  font-size: 10px;
  box-sizing: border-box;
  position: absolute;
  top: 80px;
  left: 30px;
  width: 180px;
  border-radius: 4px;
  display: flex;
  height: 58px;
  flex-direction: column;
  flex-wrap: wrap;
  .row {
    margin: 4px;
    display: flex;
    align-items: center;
  }
  a {
    text-decoration: none;
  }
`;

export const FeatureFlagIndicatorsContainerStyles = styled.div`
  position: absolute;
  top: 0;
  left: 2px;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const FeatureFlagIndicatorStyles = styled.div<{
  $active: boolean;
  $color: string;
}>`
  ${COMMON_INDICATOR_STYLES}
  margin: 4px;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  background: ${props => (props.$active ? props.$color : inactive)};
  box-shadow: 0px 0px 4px
    ${props => (props.$active ? props.$color : "transparent")};
  color: ${props => (props.$active ? "black" : inactive)};
`;

export const FeatureFlagLegendIndicatorStyles = styled.div<{
  $color: string;
}>`
  ${COMMON_INDICATOR_STYLES}
  margin-right: 4px;
  position: relative;
  background: ${props => props.$color};
  box-shadow: 0px 0px 4px ${props => props.$color};
  color: black;
`;
